import React from 'react';

const Footer = () => {
  // Empty footer - only bottom navigation is used
  return null;
};

export default Footer;
